export interface IUserProfile {
  userName: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
}

export const ME_USER = "(MOI)";
